import useProducts from './useProducts'

export default function useProduct(productId) {
    const products = useProducts()
    return products.find((x) => x.id === productId)
}
